import { blobURL } from "common/StringUtils";
import { useState } from "react";
import Carousel from "react-bootstrap/Carousel";
import { useTranslation } from "react-i18next";
import { Link, useLocation } from "react-router-dom";
import { Testimonial } from "./Testimonial";
import { LOCALES } from "common/constants";

export const Reviews = () => {
  const testmonailBg = `${blobURL}/carousel-new.png`;
  const davidMid = `${blobURL}/david-mid.jpg`;
  const selmaImg = `${blobURL}/selma.jpg`;
  const alexImg = `${blobURL}/alex-yazdani.jpg`;
  const saraImg = `${blobURL}/sara-erikson.jpg`;
  const juliaImg = `${blobURL}/juliah.jpg`;
  const { t } = useTranslation();
  const language = localStorage.getItem("i18nextLng");
  const location = useLocation();

  const [showHiddenText, setShowHiddenText] = useState(false);

  function toggleText(e) {
    e.preventDefault();
    setShowHiddenText(!showHiddenText);
  }
  return (
    <>
      <section className="discover-fakturanu">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-7">
              <div
                className="fakturanu-img position-relative"
                style={{ backgroundImage: `url(${testmonailBg})` }}
              >
                <Carousel
                  controls={false}
                  interval={"5000"}
                  variant="dark"
                  autoPlay={true}
                >
                  <Carousel.Item>
                    <Testimonial
                      name="David Midhage"
                      rating={5}
                      content="For several years, I have worked and invoiced through various invoicing services, but Invozio is undoubtedly the one that has given me the highest salary, due to their low fees."
                      content1="In addition, their website is user-friendly and their support is personalized. This has led me to see only benefits in invoicing through them!"
                      profession="Freelance consultant in the construction industry"
                      imgSrc={davidMid}
                      linkedInUrl="https://www.linkedin.com/in/david-midhage-3769b883"
                      showHiddenText={showHiddenText}
                      toggleText={toggleText}
                    />
                  </Carousel.Item>

                  <Carousel.Item>
                    <Testimonial
                      name="Selma Karamustafic"
                      rating={5}
                      content="If you're looking for a simple and efficient service, you've come to the right place. Over the years, I have tried several different invoicing services and have now found the one that suits me best."
                      content1="Invozio is easy to use, and moreover, it's the service that pays out the most money in the end of those I have tested."
                      profession="Freelance consultant in web and IT"
                      imgSrc={selmaImg}
                      linkedInUrl="https://www.linkedin.com/in/selma-karamustafic-477aa2104"
                      showHiddenText={showHiddenText}
                      toggleText={toggleText}
                    />
                  </Carousel.Item>

                  <Carousel.Item>
                    <Testimonial
                      name="Alex Yazdani"
                      rating={5}
                      content="Without a doubt, the easiest platform I've used. It took a little time to understand that you have to select a date on the calendar so that more lines would appear under the invoice part,"
                      content1="but otherwise a great platform to easily and quickly invoice and get paid without any hassle. Compared to other platforms, it is also the cheapest. Strong recommendation."
                      profession="Freelancer in the community building sector"
                      imgSrc={alexImg}
                      linkedInUrl="https://www.linkedin.com/in/alex-yazdani-4193b1130/"
                      showHiddenText={showHiddenText}
                      toggleText={toggleText}
                    />
                  </Carousel.Item>

                  <Carousel.Item>
                    <Testimonial
                      name="Sara Eriksson"
                      rating={5}
                      content="My experience with Invozio is that it is an easy-to-use service where navigating through the flow is straightforward. Their low fee makes it profitable for me to switch platforms."
                      content1="I recommend everyone to try the service, as the worst thing that can happen is that you save a few extra kronor."
                      profession="Freelancer in finance and accounting"
                      imgSrc={saraImg}
                      linkedInUrl="https://www.linkedin.com/in/sara-eriksson-856050177"
                      showHiddenText={showHiddenText}
                      toggleText={toggleText}
                    />
                  </Carousel.Item>

                  <Carousel.Item>
                    <Testimonial
                      name="Julia Hillding"
                      rating={5}
                      content="I've been using Invozio to create invoices for my individual projects, and I'm very impressed with how easy and smooth it is to use. It only takes a few minutes to create a professional"
                      content1="invoice with all the required details. I also love that I get a copy of the invoice when the customer receives their copy of the invoice and can follow up on when and if it has been paid on the platform. I recommend Invozio to other individual entrepreneurs who are looking for a simple and efficient way to manage their invoicing."
                      profession="Freelancer in design"
                      imgSrc={juliaImg}
                      linkedInUrl="https://www.linkedin.com/in/juliahillding"
                      showHiddenText={showHiddenText}
                      toggleText={toggleText}
                    />
                  </Carousel.Item>
                </Carousel>
              </div>
            </div>

            <div className="col-lg-5">
              {location.pathname === "/business" ||
              location.pathname === "/foretag" ? (
                <div className="fakturanu-content">
                  <h2>{t("CHOOSE INVOZIO FOR YOUR BUSINESS")}</h2>
                  <p>
                    {t(
                      "We offer the most cost-effective solution for businesses to manage the invoicing of employees and consultants hassle-free. With our straightforward and transparent pricing system, your company can save money while gaining access to all the necessary tools to efficiently handle billing. Our calculator assists you in easily and smoothly calculating your company’s revenue based on the invoiced amounts. With just a small fee, your business can maximize its financial gain and concentrate on growing the operation."
                    )}
                  </p>

                  <p className="last">
                    <Link
                      to={
                        language === LOCALES.EN_US
                          ? `/about-invozio?lang=${LOCALES.EN_US}`
                          : `/om-invozio?lang=${LOCALES.SV_SE}`
                      }
                      aria-label="Learn more about Invozio Platform"
                    >
                      {t("Learn more about Invozio")}

                      <svg
                        viewBox="0 0 32 32"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <title />
                        <g data-name="Layer 2" id="Layer_2">
                          <path d="M22,9a1,1,0,0,0,0,1.42l4.6,4.6H3.06a1,1,0,1,0,0,2H26.58L22,21.59A1,1,0,0,0,22,23a1,1,0,0,0,1.41,0l6.36-6.36a.88.88,0,0,0,0-1.27L23.42,9A1,1,0,0,0,22,9Z" />
                        </g>
                      </svg>
                    </Link>
                  </p>
                </div>
              ) : (
                <>
                  <div className="fakturanu-content">
                    <h2>{t("DISCOVER INVOZIO")}</h2>
                    <p>
                      {t(
                        "Invozio is a rapidly growing platform designed for freelancers and independent professionals. We empower individuals to conduct business and issue invoices without owning a company, all in an easy, efficient, and secure manner, and at competitive prices."
                      )}
                    </p>
                    <p>
                      {t(
                        "We are here to support those seeking flexibility in the job market and take pride in offering both flexibility and security to individuals across a diverse range of industries."
                      )}
                    </p>

                    <p className="last">
                      <Link
                        to={
                          language === LOCALES.EN_US
                            ? `/about-invozio?lang=${LOCALES.EN_US}`
                            : `/om-invozio?lang=${LOCALES.SV_SE}`
                        }
                        aria-label="Learn more about Invozio Platform"
                      >
                        {t("Learn more about Invozio")}

                        <svg
                          viewBox="0 0 32 32"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <title />
                          <g data-name="Layer 2" id="Layer_2">
                            <path d="M22,9a1,1,0,0,0,0,1.42l4.6,4.6H3.06a1,1,0,1,0,0,2H26.58L22,21.59A1,1,0,0,0,22,23a1,1,0,0,0,1.41,0l6.36-6.36a.88.88,0,0,0,0-1.27L23.42,9A1,1,0,0,0,22,9Z" />
                          </g>
                        </svg>
                      </Link>
                    </p>
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      </section>
    </>
  );
};
